import { render } from "./preloader.vue?vue&type=template&id=02874ecc&scoped=true"
import script from "./preloader.vue?vue&type=script&lang=js"
export * from "./preloader.vue?vue&type=script&lang=js"

import "./preloader.vue?vue&type=style&index=0&id=02874ecc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02874ecc"]])

export default __exports__